import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../api';

const TABS = ['login', 'signup', 'reset'];
const TAB_LABELS = { login: 'Sign In', signup: 'Create Account', reset: 'Forgot Password' };

export default function AdminLogin() {
  const [tab, setTab] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const switchTab = (t) => { setTab(t); setError(''); setSuccess(''); };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(username, password);
      navigate('/dash');
    } catch {
      setError('Invalid username or password');
    } finally { setLoading(false); }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/auth/register', { username, password, invite_code: inviteCode });
      await login(username, password);
      navigate('/dash');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setSuccess('');
    try {
      await api.post('/auth/reset-password', { username, invite_code: inviteCode, new_password: newPassword });
      setSuccess('Password updated. You can now sign in.');
      setTimeout(() => switchTab('login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed');
    } finally { setLoading(false); }
  };

  const tabStyle = (active) => ({
    flex: 1, padding: '10px', background: 'none', border: 'none',
    borderBottom: active ? '2px solid #2B7FFF' : '2px solid transparent',
    color: active ? '#2B7FFF' : '#555', fontWeight: active ? 700 : 400,
    fontSize: '11px', letterSpacing: '0.06em', textTransform: 'uppercase',
    cursor: 'pointer', transition: 'all 0.15s',
  });

  return (
    <div style={{ minHeight: '100vh', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ color: '#2B7FFF', fontWeight: 900, fontSize: '24px', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: '4px' }}>Mane</div>
          <p style={{ color: '#555', fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Dashboard</p>
        </div>

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            {TABS.map(t => <button key={t} style={tabStyle(tab === t)} onClick={() => switchTab(t)}>{TAB_LABELS[t]}</button>)}
          </div>

          <div style={{ padding: '28px' }}>
            {tab === 'login' && (
              <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div><label className="label">Username</label><input className="input" value={username} onChange={e => setUsername(e.target.value)} required autoFocus autoComplete="username" /></div>
                <div><label className="label">Password</label><input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" /></div>
                {error && <div style={{ color: '#ef4444', fontSize: '13px', textAlign: 'center', background: 'rgba(239,68,68,0.08)', padding: '10px', borderRadius: '4px' }}>{error}</div>}
                <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ padding: '16px', marginTop: '4px' }}>{loading ? '...' : 'Sign In'}</button>
              </form>
            )}

            {tab === 'signup' && (
              <form onSubmit={handleSignup} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div><label className="label">Username</label><input className="input" value={username} onChange={e => setUsername(e.target.value)} required autoFocus autoComplete="username" /></div>
                <div><label className="label">Password</label><input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="new-password" /></div>
                <div><label className="label">Invite Code</label><input className="input" value={inviteCode} onChange={e => setInviteCode(e.target.value)} required placeholder="Required to create account" /></div>
                {error && <div style={{ color: '#ef4444', fontSize: '13px', textAlign: 'center', background: 'rgba(239,68,68,0.08)', padding: '10px', borderRadius: '4px' }}>{error}</div>}
                <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ padding: '16px', marginTop: '4px' }}>{loading ? '...' : 'Create Account'}</button>
              </form>
            )}

            {tab === 'reset' && (
              <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div><label className="label">Username</label><input className="input" value={username} onChange={e => setUsername(e.target.value)} required autoFocus autoComplete="username" /></div>
                <div><label className="label">New Password</label><input className="input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required autoComplete="new-password" /></div>
                <div><label className="label">Invite Code</label><input className="input" value={inviteCode} onChange={e => setInviteCode(e.target.value)} required placeholder="Prove you're authorized" /></div>
                {error && <div style={{ color: '#ef4444', fontSize: '13px', textAlign: 'center', background: 'rgba(239,68,68,0.08)', padding: '10px', borderRadius: '4px' }}>{error}</div>}
                {success && <div style={{ color: '#10b981', fontSize: '13px', textAlign: 'center', background: 'rgba(16,185,129,0.08)', padding: '10px', borderRadius: '4px' }}>{success}</div>}
                <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ padding: '16px', marginTop: '4px' }}>{loading ? '...' : 'Reset Password'}</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
